import { render, staticRenderFns } from "./ServicesBlock.vue?vue&type=template&id=d940e576&scoped=true&lang=pug"
import script from "./ServicesBlock.vue?vue&type=script&lang=ts"
export * from "./ServicesBlock.vue?vue&type=script&lang=ts"
import style0 from "./ServicesBlock.vue?vue&type=style&index=0&id=d940e576&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d940e576",
  null
  
)

export default component.exports